<template>
  <v-dialog v-model="autorizar" persistent max-width="490">
    <template v-slot:activator="{ on }">
      <v-icon small class="mr-2" v-on="on">mdi-pencil</v-icon>
    </template>
    <v-card>
      <v-card-title class="headline">
        Autorizaci&oacute;n de Abono:
        <code class="ml-3">{{abono.factura}}</code>
      </v-card-title>
      <v-card-text>Una vez Aceptado el abono se enviar&aacute; un correo a servicio t&eacute;cnico para que revisen el producto, una vez el t&eacute;cnico revise y acepte el tramite recibir&aacute; un correo con la solicitud aceptada.</v-card-text>
      <v-divider></v-divider>
      <v-row class="mx-3">
        <v-col cols="12">
          <v-textarea v-model="abono.condiciones" label="Condiciones" hint="Condiciones del Abono"></v-textarea>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-btn color="red darken-1" text @click="autorizar = false">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="denegarAbono(abono)">Denegar</v-btn>
        <v-btn color="green darken-1" text @click="aceptarAbono(abono)">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Editar",
  data() {
    return {
      autorizar: false,
      classAutorizar: {
        color: "primary darken-1",
        text: "En espera"
      }
    };
  },
  props: ["abono"],
  methods: {
    ...mapActions(["autorizarAbono"]),
    aceptarAbono(abono) {
      this.classAutorizar.color = "green";
      this.classAutorizar.text = "Aceptado";
      this.autorizarAbono([abono, this.classAutorizar]);
      this.autorizar = false;
    },
    denegarAbono(abono) {
      this.classAutorizar.color = "red";
      this.classAutorizar.text = "Denegado";
      this.autorizarAbono([abono, this.classAutorizar]);
      this.autorizar = false;
    }
  }
};
</script>